import React, { useEffect, useState } from "react";
import Logo from "../../../assets/svg/akinrobotics-logo-white.svg";
export default function PreviewFooter({ footerBackgroundPath }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    
    // Temizleme
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="w-full flex rounded-lg">
      <div className="w-full">
        <div
          className="relative z-0 w-full group bg-gradient-to-r from-cyan-500 to-blue-500 flex justify-center items-center text-center py-8"
          style={{
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 5,
            ...(footerBackgroundPath ? {
              backgroundImage: `url(${footerBackgroundPath})`, // Eğer geçerli bir path varsa, arka plan resmi uygulanır
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            } : {}), // Eğer geçerli bir path yoksa, backgroundImage ve diğer özellikler uygulanmaz
            
            textAlign: 'center',
            paddingTop: '16px',
            paddingBottom: '16px',
            position: 'fixed',
            ...(windowWidth<=800 ? {
              height: '100px'
            }: {height: '80px'})
          }}
        >
          


          {/* Logo kısmı */}
          {!footerBackgroundPath ? (
          <div className="divider text-white relative z-10">
            <img
              className="h-14 text-white"
              src={Logo}
              alt="Logo"
            />
          </div>
           ) : null}
        </div>
      </div>
    </div>



  );
}
